import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronTriangleDownSmall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconChevronTriangleDownSmall"><Path d="M7.17432 10.25L12 16.1894L16.8258 10.25H7.17432Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronTriangleDownSmall;
